<div>
  <mat-icon>priority_high</mat-icon>
  <span i18n="@@ideal-product-not-returnable.message">No Returns</span>
</div>
